<template>
    <mped-cost-deps-component :is-plan="true"></mped-cost-deps-component>
</template>

<script>
export default  {
    name: 'mped-cost-planning-deps-view'
}
</script>

<script setup>
import MpedCostDepsComponent from '@/views/mped/components/mped-cost-deps-component.vue';
</script>
